import React from 'react';
import { ProductReview } from '../types';
import ReviewSingle from './ReviewSingle';
import ReviewSingleWithFields from './ReviewSingleWithFields';

interface ReviewsProps {
  reviews: ProductReview[];
  canLoadMore?: boolean;
  loadMoreClicked?: () => void;
  customFields?: Array<{ name: string; key: string }>;
}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & ReviewsProps>;

const Reviews: Props = ({ className, children, reviews, canLoadMore, loadMoreClicked, customFields, ...props }) => {
  return (
    <div {...props} className={`divide-y-1 divide-solid divide-gray ${className ? className : ''}`}>
      {reviews.map((review, index) =>
        customFields ? (
          <ReviewSingleWithFields
            key={review.id}
            review={review}
            customFields={customFields}
            className={`${index == 0 ? 'pt-0' : ''}`}
          />
        ) : (
          <ReviewSingle key={review.id} review={review} className={`${index == 0 ? 'pt-0' : ''}`} />
        )
      )}

      {canLoadMore && (
        <div className="pt-32">
          <button className="btn-info btn" onClick={loadMoreClicked}>
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default Reviews;
